import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    modulePortailBailleurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePortailBailleur.key);
    },
    ligneCommandeARenouvelerSpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.ligneCommandeARenouvelerSpe.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      PARAMETRES_INTERNE_KEYS.modulePresse.key,
      PARAMETRES_INTERNE_KEYS.modulePortailBailleur.key,
      PARAMETRES_INTERNE_KEYS.ligneCommandeARenouvelerSpe.key,
      PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
    ]);
  },
};
